var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vx-card", [
    _c("div", [
      _c(
        "div",
        { staticClass: "font-semibold text-grey select-none w-full text-left" },
        [_vm._v(" CONFIGURAÇÕES ")]
      )
    ]),
    _c("hr", { staticStyle: { "margin-top": "0.25rem" } }),
    _c(
      "div",
      [
        _c(
          "b-form-group",
          {
            attrs: {
              id: "version-selector",
              label: "API:",
              "label-for": "api-version"
            }
          },
          [
            _c("b-form-select", {
              attrs: {
                id: "api-version",
                options: [
                  {
                    value: "v1",
                    text: "Versão 1"
                  },
                  {
                    value: "v2",
                    text: "Versão 2"
                  }
                ]
              },
              model: {
                value: _vm.apiVersion,
                callback: function($$v) {
                  _vm.apiVersion = $$v
                },
                expression: "apiVersion"
              }
            })
          ],
          1
        ),
        _c(
          "b-form-group",
          { attrs: { label: "Exceções", id: "response-flags" } },
          [
            _c(
              "div",
              { staticClass: "flex w-full flex-wrap gap-10" },
              [
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.flags.pe,
                      callback: function($$v) {
                        _vm.$set(_vm.flags, "pe", $$v)
                      },
                      expression: "flags.pe"
                    }
                  },
                  [_vm._v(" PHP ")]
                ),
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.flags.tpe,
                      callback: function($$v) {
                        _vm.$set(_vm.flags, "tpe", $$v)
                      },
                      expression: "flags.tpe"
                    }
                  },
                  [_vm._v(" Terceiros (Biblioteca) ")]
                ),
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.flags.ne,
                      callback: function($$v) {
                        _vm.$set(_vm.flags, "ne", $$v)
                      },
                      expression: "flags.ne"
                    }
                  },
                  [_vm._v(" Notificação ")]
                ),
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.flags.ve,
                      callback: function($$v) {
                        _vm.$set(_vm.flags, "ve", $$v)
                      },
                      expression: "flags.ve"
                    }
                  },
                  [_vm._v(" Validação ")]
                ),
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.flags.ge,
                      callback: function($$v) {
                        _vm.$set(_vm.flags, "ge", $$v)
                      },
                      expression: "flags.ge"
                    }
                  },
                  [_vm._v(" Primeiros (Exception) ")]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "b-form-group",
          { attrs: { label: "Feedback Frontend" } },
          [
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.useVsLoading,
                  callback: function($$v) {
                    _vm.useVsLoading = $$v
                  },
                  expression: "useVsLoading"
                }
              },
              [_vm._v(" Overlay de Carregamento ")]
            ),
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.showResponse,
                  callback: function($$v) {
                    _vm.showResponse = $$v
                  },
                  expression: "showResponse"
                }
              },
              [_vm._v(" Mostrar Mensagem Sucesso ")]
            ),
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.showError,
                  callback: function($$v) {
                    _vm.showError = $$v
                  },
                  expression: "showError"
                }
              },
              [_vm._v(" Mostrar Mensagem Erro ")]
            )
          ],
          1
        ),
        _c(
          "b-form-group",
          {
            attrs: {
              id: "controller-return-group",
              label: "Controller Retorna:",
              "label-for": "controller-return"
            }
          },
          [
            _c("b-form-select", {
              attrs: {
                id: "controller-return",
                options: [
                  {
                    value: "jsonresource",
                    text: "Json Resource"
                  },
                  {
                    value: "array",
                    text: "Array"
                  },
                  {
                    value: "collection",
                    text: "Collection"
                  },
                  {
                    value: "object",
                    text: "Object"
                  },
                  {
                    value: "string",
                    text: "String"
                  },
                  {
                    value: "number",
                    text: "Number"
                  }
                ]
              },
              model: {
                value: _vm.controllerReturn,
                callback: function($$v) {
                  _vm.controllerReturn = $$v
                },
                expression: "controllerReturn"
              }
            })
          ],
          1
        ),
        _c(
          "b-form-group",
          {
            attrs: {
              label: "Forçar Status de Retorno",
              "label-for": "status-force"
            }
          },
          [
            _c("b-form-input", {
              attrs: { type: "number", id: "status-force" },
              model: {
                value: _vm.statusForced,
                callback: function($$v) {
                  _vm.statusForced = $$v
                },
                expression: "statusForced"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "pt-2" }, [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "font-semibold text-grey select-none w-full text-left"
          },
          [_vm._v(" OPERAÇÕES ")]
        )
      ]),
      _c("hr", { staticStyle: { "margin-top": "0.25rem" } }),
      _c(
        "div",
        { staticClass: "flex justify-center gap-4" },
        [
          _c(
            "b-button",
            { attrs: { variant: "primary" }, on: { click: _vm.testSearch } },
            [_vm._v(" Busca ")]
          ),
          _c(
            "b-button",
            { attrs: { variant: "danger" }, on: { click: _vm.testNotFound } },
            [_vm._v(" 404 ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }